import React, { memo } from "react";
import { TableBody, TableBodyProps } from "@mui/material";

const AppTableBody = ({ children, sx, ...otherProps }: TableBodyProps) => {
  return (
    <TableBody
      sx={{
        ...sx,
      }}
      {...otherProps}
    >
      {children}
    </TableBody>
  );
};

export default memo(AppTableBody);
